import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, CreditCard, CheckCircle2 } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-brand-dark text-white pt-12 pb-10 md:pt-28 md:pb-24 overflow-hidden" data-id="element-106">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-107">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-brand-ice blur-3xl" data-id="element-108"></div>
        <div className="absolute top-40 -left-20 w-72 h-72 rounded-full bg-brand-accent blur-3xl" data-id="element-109"></div>
      </div>

      <div className="max-w-6xl mx-auto px-3 sm:px-6 lg:px-8 relative z-10" data-id="element-110">
        <div className="flex flex-col items-center text-center" data-id="element-111">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="mb-4 md:mb-6" data-id="element-112">
            <span className="bg-brand-light text-brand-ice text-xs md:text-sm font-semibold px-3 md:px-4 py-1 md:py-1.5 rounded-full uppercase tracking-wider border border-slate-700" data-id="element-113">
              Sistema N°1 para Profesores en Argentina
            </span>
          </motion.div>

          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight max-w-4xl" data-id="element-114">
            Todo tu año de{' '}
            <span className="text-brand-accent" data-id="element-115">Patinaje Artístico</span>{' '}
            Resuelto
          </motion.h1>

          {/* Mockup Image at 70% */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative my-6 md:my-10 w-[70%] max-w-lg mx-auto" data-id="element-116">
            <div className="absolute inset-0 bg-gradient-to-tr from-brand-accent/20 to-transparent rounded-3xl blur-2xl" data-id="element-117"></div>
            <img src="https://cdn.magicpatterns.com/uploads/dSanz2x84KNwq3jfCJyaNm/heylloyd-image-1777340553276-Photoroom.png" alt="Patinaje Artístico Resuelto Megapack 6 Tomos" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-118" />
          </motion.div>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="md:text-xl text-slate-300 font-light text-[12px]" data-id="element-119">
            PATINAJE ARTÍSTICO RESUELTO Megapack
            <br data-id="element-120" />
            <strong className="text-white font-semibold" data-id="element-121">
              6 Tomos + 6 Bonos
            </strong>{' '}
            | Envío digital inmediato
          </motion.p>

          {/* Description */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-sm md:text-base text-slate-400 mt-4 max-w-2xl" data-id="element-122">
            Tu año completo de clases de patinaje artístico listo: fundamentos,
            técnica, coreografía, planificación por niveles, evaluación,
            preparación física y mucho más.{' '}
            <strong className="text-white" data-id="element-123">Sin improvisar nunca más.</strong>
          </motion.p>

          {/* Checklist */}
          <motion.ul initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="space-y-1.5 md:space-y-2 text-sm text-slate-300 mt-4 md:mt-6" data-id="element-124">
            <li className="flex items-center justify-center" data-id="element-125">
              <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-2 flex-shrink-0" data-id="element-126" />{' '}
              PDF digital · Acceso inmediato
            </li>
            <li className="flex items-center justify-center" data-id="element-127">
              <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-2 flex-shrink-0" data-id="element-128" />{' '}
              Todos los niveles
            </li>
            <li className="flex items-center justify-center" data-id="element-129">
              <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-2 flex-shrink-0" data-id="element-130" />{' '}
              Garantía 7 días
            </li>
          </motion.ul>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="pt-4 md:pt-6" data-id="element-131">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={scrollToPricing} className="w-full sm:w-auto bg-brand-accent hover:bg-brand-accentHover text-brand-dark font-bold text-base md:text-lg px-6 md:px-8 py-3 md:py-4 rounded-xl shadow-lg shadow-brand-accent/20 transition-all flex items-center justify-center animate-pulse-slow" data-id="element-132">
              💥 QUIERO MI PATINAJE ARTÍSTICO RESUELTO
            </motion.button>

            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mt-3 md:mt-4 text-xs text-slate-400" data-id="element-133">
              <div className="flex items-center" data-id="element-134">
                <ShieldCheck className="w-3.5 h-3.5 mr-1" data-id="element-135" /> Pago 100% seguro
              </div>
              <div className="flex items-center" data-id="element-136">
                <CreditCard className="w-3.5 h-3.5 mr-1" data-id="element-137" /> Mercado Pago |
                Tarjeta | Transferencia
              </div>
            </div>
          </motion.div>

          {/* Social Proof Bar */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.7
        }} className="flex items-center justify-center space-x-3 md:space-x-4 mt-6 md:mt-8 pt-4 md:pt-6 border-t border-slate-800 w-full max-w-md" data-id="element-138">
            <div className="flex -space-x-2" data-id="element-139">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-slate-700 border-2 border-brand-dark flex items-center justify-center text-[10px] md:text-xs font-bold text-slate-300" data-id="element-140">
                  P{i}
                </div>)}
            </div>
            <div data-id="element-141">
              <div className="flex text-brand-accent" data-id="element-142">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-current" data-id="element-143" />)}
                <span className="ml-1 text-white font-bold text-xs md:text-sm" data-id="element-144">
                  4.9/5
                </span>
              </div>
              <p className="text-[10px] md:text-xs text-slate-400" data-id="element-145">
                +200 profes confían · 🇦🇷 Todo el país
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}